export class ListarMateriasPublicadasHtmlInputDto {
  constructor(
    public edicaoId: number,
    public paginaAtual: number,
    public cadernoEdicaoId?: number,
    public publicacaoId?: number,
    public entidadeId?: number,
    public municipioId?: number,
    public secaoId?: number
  ) {}
}
